import React from 'react';

import { Flex, Text } from 'common/common-components.styled';
import { DamageReportForm } from 'components/icons-new/damage-report-form';

export const OtpInactivePlaceholder = () => {
  return (
    <Flex direction='column' align='center' margin='auto'>
      <DamageReportForm />

      <Text color='darkBlue' size='20' bold top='40' bottom='10'>
        Das Formular wurde erfolgreich ausgefüllt.
      </Text>
      <Text color='darkBlue' bold>
        Wenn Sie Fragen oder Ergänzungen haben, wenden Sie sich bitte an das Mobexo-Team.
      </Text>
    </Flex>
  );
};
